import { cn } from "../lib/utils.ts";

export type Status = "idle" | "listening" | "thinking" | "speaking" | "error" | "offline";

const STYLES: Record<Status, { label: string; color: string }> = {
  idle: { label: "Tap the mic to start", color: "bg-white/10 text-white" },
  listening: { label: "Listening…", color: "bg-emerald-400/90 text-emerald-950" },
  thinking: { label: "Thinking…", color: "bg-amber-300/90 text-amber-950" },
  speaking: { label: "Speaking", color: "bg-violet-400/90 text-violet-950" },
  error: { label: "Something went wrong", color: "bg-rose-500/90 text-white" },
  offline: { label: "Connecting…", color: "bg-slate-500/80 text-white" },
};

export function StatusBanner({
  status,
  message,
}: {
  status: Status;
  message?: string;
}) {
  const cfg = STYLES[status];
  return (
    <div
      className={cn(
        "px-6 py-3 rounded-full text-lg font-bold shadow-lg transition-colors",
        cfg.color,
      )}
    >
      {message || cfg.label}
    </div>
  );
}
